import manage from './manage'
import submit from './submit'
import intercept from './intercept'
import { universalPermissions } from '@/services/smart'
const state = {
  permissions: {}
}
const mutations = {
  setPermissions (state, data) {
    state.permissions = data
  }
}
const actions = {
  // 获取外部表单权限相关
  async getUniversalPermissions ({ commit }, params) {
    commit('SET_LOADING', true)
    const chain = await universalPermissions()
      .params()
      .onSuccess(res => {
        commit('setPermissions', res)
      })
      .fetch()
    return chain
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  modules: {
    manage,
    submit,
    intercept
  }
}
